(function () {
  function escPersoInit() {
    var container = document.querySelector('[data-perso-variant-id]');
    if (!container) return;

    var persoVariantId = parseInt(container.dataset.persoVariantId, 10);
    var formId = container.dataset.productFormId;
    var form = document.getElementById(formId);
    var checkbox = container.querySelector('.esc-perso__input');
    var fieldsEl = container.querySelector('.esc-perso__fields');
    var nombreInput = container.querySelector('#' + fieldsEl.id.replace('fields', 'nombre'));
    var numeroInput = container.querySelector('#' + fieldsEl.id.replace('fields', 'numero'));
    var errorEl = container.querySelector('.esc-perso__error');

    if (!form || !checkbox || !persoVariantId || !fieldsEl) return;

    // --- Toggle fields when checkbox changes ---
    checkbox.addEventListener('change', function () {
      if (this.checked) {
        fieldsEl.classList.add('esc-perso__fields--visible');
        fieldsEl.setAttribute('aria-hidden', 'false');
        if (nombreInput) nombreInput.focus();
      } else {
        fieldsEl.classList.remove('esc-perso__fields--visible');
        fieldsEl.setAttribute('aria-hidden', 'true');
        clearErrors();
        if (nombreInput) nombreInput.value = '';
        if (numeroInput) numeroInput.value = '';
      }
    });

    // --- Clear error styling on input ---
    [nombreInput, numeroInput].forEach(function (inp) {
      if (!inp) return;
      inp.addEventListener('input', function () {
        inp.classList.remove('esc-perso__field-input--error');
        clearErrors();
      });
    });

    function clearErrors() {
      if (errorEl) errorEl.textContent = '';
    }

    function showError(msg, focusEl) {
      if (errorEl) errorEl.textContent = msg;
      if (focusEl) {
        focusEl.classList.add('esc-perso__field-input--error');
        focusEl.focus();
      }
    }

    // --- Form submit interception ---
    var skipIntercept = false;

    form.addEventListener(
      'submit',
      function (e) {
        // Second pass: skip our logic, let Sense handle the jersey normally
        if (skipIntercept) {
          skipIntercept = false;
          return;
        }

        // Personalización not selected → Sense handles everything as normal
        if (!checkbox.checked) return;

        // Validate fields (required)
        var nombre = nombreInput ? nombreInput.value.trim() : '';
        var numero = numeroInput ? numeroInput.value.trim() : '';

        if (!nombre && !numero) {
          e.preventDefault();
          e.stopImmediatePropagation();
          showError('Por favor ingresa el nombre y número del jugador.', nombreInput);
          return;
        }
        if (!nombre) {
          e.preventDefault();
          e.stopImmediatePropagation();
          showError('Por favor ingresa el nombre del jugador.', nombreInput);
          return;
        }
        if (!numero) {
          e.preventDefault();
          e.stopImmediatePropagation();
          showError('Por favor ingresa el número del jugador.', numeroInput);
          return;
        }

        // Validation passed — intercept and add personalization first
        e.preventDefault();
        e.stopImmediatePropagation();

        clearErrors();

        var qtyInput = form.querySelector('[name="quantity"]');
        var qty = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;

        skipIntercept = true;

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            items: [{
              id: persoVariantId,
              quantity: qty,
              properties: {
                'Nombre': nombre.toUpperCase(),
                'Número': numero
              }
            }]
          })
        })
          .then(function () {
            form.requestSubmit();
          })
          .catch(function () {
            // Even if perso add fails, still proceed with jersey
            form.requestSubmit();
          });
      },
      true // capture phase — runs before Sense's bubbling handler
    );
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', escPersoInit);
  } else {
    escPersoInit();
  }
})();
